/**
 * Extensões consideradas perigosas (executáveis, scripts e instaladores).
 * Arquivos com essas extensões não podem ser anexados no chat.
 */
export const BLOCKED_FILE_EXTENSIONS: string[] = [
  // Executáveis / instaladores
  'exe',
  'msi',
  'msix',
  'msp',
  'com',
  'scr',
  'pif',
  'cpl',
  'dll',
  'sys',
  'drv',
  'ocx',
  'app',
  'dmg',
  'pkg',
  'deb',
  'rpm',
  'appimage',
  'apk',
  'ipa',
  'gadget',
  // Scripts de sistema
  'bat',
  'cmd',
  'sh',
  'bash',
  'zsh',
  'csh',
  'ksh',
  'ps1',
  'psm1',
  'psd1',
  'vb',
  'vbs',
  'vbe',
  'js',
  'jse',
  'mjs',
  'cjs',
  'wsf',
  'wsh',
  'ws',
  'hta',
  'jar',
  'class',
  'py',
  'pyc',
  'pyw',
  'pl',
  'php',
  'rb',
  'lua',
  // Atalhos / arquivos de configuração que executam código
  'lnk',
  'url',
  'inf',
  'reg',
  'scf',
  'chm',
  'hlp',
  'job',
  'workflow',
  'action',
  'command',
  'desktop',
  'service',
  // Macros do Office
  'docm',
  'dotm',
  'xlm',
  'xlsm',
  'xltm',
  'xlam',
  'pptm',
  'potm',
  'ppam',
  'ppsm',
  'sldm',
];

/**
 * Retorna a extensão do arquivo em minúsculas, sem o ponto.
 * Remove espaços, pontos e caracteres invisíveis no final do nome, usados para
 * burlar a validação (ex.: "virus.exe." é executado como "virus.exe" no Windows).
 */
export function getFileExtension(fileName: string): string {
  const sanitizedName = (fileName ?? '')
    .trim()
    .replace(/[\s.\u200b-\u200f\u202a-\u202e\u2066-\u2069]+$/, '');
  const lastDotIndex = sanitizedName.lastIndexOf('.');

  if (lastDotIndex < 1) {
    return '';
  }

  return sanitizedName.slice(lastDotIndex + 1).toLowerCase();
}

/** Indica se a extensão do arquivo está na lista de extensões bloqueadas. */
export function hasBlockedExtension(fileName: string): boolean {
  const extension = getFileExtension(fileName);
  return extension !== '' && BLOCKED_FILE_EXTENSIONS.includes(extension);
}

/** Mensagem de aviso para os arquivos recusados. */
export function blockedAttachmentsMessage(blocked: File[]): string {
  if (blocked.length === 1) {
    return `O arquivo "${blocked[0].name}" não é permitido. Envie apenas imagens ou PDF.`;
  }

  return `${blocked.length} arquivos não são permitidos e foram removidos. Envie apenas imagens ou PDF.`;
}
